import { connect } from 'react-redux'
import UI from './UI'
import { AddItemToCartAction } from 'components/Cart/store'
import { push } from 'connected-react-router'
import { defaultCurrency, switchDefaultCurrencyAction } from 'store/currency'
import { AddSubscriptionToCartAction, SelectInitialChoice } from 'components/CheckoutSubscription/store'
import { billingCycleId, OnBoardingStateEnum } from 'constants/'
import { decorateUrl } from 'components/common/UTMscript'
import { HomePath } from 'navigation/Routes'
import { setTrialState } from 'components/Profile/store'
import { initOnboarding, setIsCheckoutOnboarding } from 'pages/OnBoardingNext/store'
import { signup } from 'identity/userManager'

const mapStateToProps = ({ course, support, identity, currency, referential, user }) => {
  const initialCurrency = currency.initialCurrency
  const annual = support?.SubscriptionTypePrices?.find(item => item.BillingCycle === billingCycleId.annual)
  const monthly = support?.SubscriptionTypePrices?.find(item => item.BillingCycle === billingCycleId.monthly)
  return {
    Price: course.Course.Price,
    AlternativePrice: course?.Course?.AlternativePrice,
    phone: support.Phone,
    ProfileType: referential?.ProfileTypes ? referential?.ProfileTypes[user?.ProfileType] : null,
    Id: course.Course.Id,
    Title: course.Course.Title,
    Image: course.Course.Image,
    MobileImageUrl: course.Course.MobileImageUrl,
    Rating: course.Course.Rating,
    ReviewersCount: course.Course.ReviewersCount,
    Duration: course.Course.Duration,
    ViewersCount: course.Course.ViewersCount,
    Slug: course.Course.Slug,
    isDefault: support.IsDefault,
    initialCurrency: currency.initialCurrency,
    alternativeCurrency: currency.alternativeCurrency,
    annualPrice: initialCurrency === defaultCurrency ? annual?.AlternativePrice : annual?.Price,
    monthlyPrice: initialCurrency === defaultCurrency ? monthly?.AlternativePrice : monthly?.Price,
    annualPricePromo: initialCurrency === defaultCurrency ? annual?.Promotion?.AlternativePromotionPrice : annual?.Promotion?.PromotionPrice,
    monthlyPricePromo: initialCurrency === defaultCurrency ? monthly?.Promotion?.AlternativePromotionPrice : monthly?.Promotion?.PromotionPrice,
    isConnected: identity.isConnected,
    PricePromo: course.Course.PricePromo,
    AlternativePricePromo: course.Course.AlternativePricePromo,
    isElligableForTrial: user.isElligableForTrial
  }
}

const mapDispatchToProps = (dispatch) => ({
  addToCart: course => dispatch(AddItemToCartAction(course)),
  switchCurrency: () => dispatch(switchDefaultCurrencyAction()),
  goToUrl: link => dispatch(push(decorateUrl(link))),
  goHome: () => dispatch(push(HomePath)),
  selectInitialChoice: data => dispatch(SelectInitialChoice(data)),
  addSubscriptionToCart: () => dispatch(AddSubscriptionToCartAction()),
  signup,
  setTrialState: (data) => dispatch(setTrialState(data)),
  startTrialOnboarding: () => dispatch(initOnboarding(OnBoardingStateEnum.Start)),
  setCheckoutOnboarding: (data) => dispatch(setIsCheckoutOnboarding(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(UI)
